import dynamicLocalization from "@/mixins/dynamic-localization";
import SegmentedContent from "./segmented-content/index";

export default {
  components: { SegmentedContent },
  mixins: [dynamicLocalization],
  props: { lines: { type: Array, required: true } },
};
